"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const second_step_1 = require("@/room/room_create/second_step");
function default_1() {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (0, jsx_runtime_1.jsx)(second_step_1.SubNotice, { noticeType: t('알림'), noticeLine: t('폰디 커미션은 업데이트중!') });
}
exports.default = default_1;
